/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ClaudeTurnUsage = {
  /**
   * Cache creation tokens used by this turn.
   */
  cacheCreationTokens: number;
  /**
   * Cache read tokens used by this turn.
   */
  cacheReadTokens: number;
  /**
   * Total cost for this turn in micros of a USD.
   */
  costMicros: number;
  /**
   * Total USD cost for this turn.
   */
  costUsd: number;
  /**
   * Latest OTEL log timestamp in this turn, as Unix nanoseconds.
   */
  endTimeUnixNano: string;
  /**
   * Input tokens used by this turn.
   */
  inputTokens: number;
  /**
   * Distinct model names used by this turn.
   */
  models: Array<string>;
  /**
   * Output tokens used by this turn.
   */
  outputTokens: number;
  /**
   * Claude prompt.id that correlates events for one user turn.
   */
  promptId: string;
  /**
   * Distinct Claude query sources used by this turn.
   */
  querySources: Array<string>;
  /**
   * Number of Claude API request events in this turn.
   */
  requestCount: number;
  /**
   * Earliest OTEL log timestamp in this turn, as Unix nanoseconds.
   */
  startTimeUnixNano: string;
  /**
   * Total tokens used by this turn.
   */
  totalTokens: number;
};

/** @internal */
export const ClaudeTurnUsage$inboundSchema: z.ZodMiniType<
  ClaudeTurnUsage,
  unknown
> = z.pipe(
  z.object({
    cache_creation_tokens: z.int(),
    cache_read_tokens: z.int(),
    cost_micros: z.int(),
    cost_usd: z.number(),
    end_time_unix_nano: z.string(),
    input_tokens: z.int(),
    models: z.array(z.string()),
    output_tokens: z.int(),
    prompt_id: z.string(),
    query_sources: z.array(z.string()),
    request_count: z.int(),
    start_time_unix_nano: z.string(),
    total_tokens: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "cache_creation_tokens": "cacheCreationTokens",
      "cache_read_tokens": "cacheReadTokens",
      "cost_micros": "costMicros",
      "cost_usd": "costUsd",
      "end_time_unix_nano": "endTimeUnixNano",
      "input_tokens": "inputTokens",
      "output_tokens": "outputTokens",
      "prompt_id": "promptId",
      "query_sources": "querySources",
      "request_count": "requestCount",
      "start_time_unix_nano": "startTimeUnixNano",
      "total_tokens": "totalTokens",
    });
  }),
);

export function claudeTurnUsageFromJSON(
  jsonString: string,
): SafeParseResult<ClaudeTurnUsage, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ClaudeTurnUsage$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ClaudeTurnUsage' from JSON`,
  );
}
